import { graphql } from 'gql';

export const bimWorkOrderChangeDefaultsGql = graphql(`
    query bimWorkOrderChangeDefaults($workOrderId: Long!) {
        bimWorkOrderChangeDefaults(workOrderId: $workOrderId) {
            data {
                authoredBy
                createdAt
                seasonDistributions {
                    seasonValue
                    year
                }
                status
                subject
            }
        }
    }
`);

export const bimIsUniqueWorkOrderChangeInternalNumberGql = graphql(`
    query bimIsUniqueWorkOrderChangeInternalNumber(
        $workOrderChangeId: Long
        $workOrderId: Long!
        $internalNumber: String!
    ) {
        bimIsUniqueWorkOrderChangeInternalNumber(
            workOrderChangeId: $workOrderChangeId
            workOrderId: $workOrderId
            internalNumber: $internalNumber
        ) {
            result
        }
    }
`);

export const bimCreateWorkOrderChangeGql = graphql(`
    mutation bimCreateWorkOrderChange($input: BimWorkOrderChangeCreateInput!) {
        bimCreateWorkOrderChange(input: $input) {
            data {
                id
            }
            message
            result
            validation {
                property
                message
                metadata
            }
        }
    }
`);

export const bimUpdateWorkOrderChangeGql = graphql(`
    mutation bimUpdateWorkOrderChange($input: BimWorkOrderChangeUpdateInput!) {
        bimUpdateWorkOrderChange(input: $input) {
            data {
                id
            }
            message
            result
            validation {
                property
                message
                metadata
            }
        }
    }
`);
